module.exports = __webpack_public_path__ + "img/Keystone Bank Limited.b876a2f4.png";